var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbstractOpacoServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1750,
    height: 527,
    viewBox: "0 0 1750 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 518.264C155.022 502.683 327.88 497.372 498.361 509.669C567.993 514.69 637.814 517.169 707.469 511.89C783.43 506.128 855.744 483.144 930.692 469.109C1063.98 444.129 1199.13 502.812 1331.85 512.598C1471.66 522.931 1608.95 496.084 1749.11 520.549",
    stroke: "url(#paint0_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 482.403C161.609 455.653 344.888 450.76 522.144 474.774C593.211 484.399 664.867 489.485 736.051 479.281C820.057 467.274 892.959 423.044 973.789 396.036C1108.8 350.937 1242.08 460.449 1374.62 478.251C1432.8 486.073 1490.38 468.98 1548.42 463.862C1617.04 457.778 1682.51 467.467 1749.11 490.741",
    stroke: "url(#paint1_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 443.517C167.043 407.367 354.439 411.81 536.847 445.32C608.62 458.486 680.44 465.729 752.377 450.47C789.805 442.519 826.314 429.16 862.025 411.938C910.579 388.536 955.346 345.529 1003.5 324.026C1138.65 263.669 1266.9 417.668 1395.06 445.191C1453.87 457.81 1507.53 431.639 1565.47 422.593C1630 412.518 1688.77 429.772 1749.13 460.965",
    stroke: "url(#paint2_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 402.185C163.209 359.404 345.499 372.795 523.297 416.092C600.457 434.891 677.734 447.284 755.365 425.717C853.932 398.322 926.623 317.234 1016.86 265.408C1163.21 181.358 1279.75 385.253 1416.26 416.253C1470.15 428.485 1514.59 397.26 1566.18 383.644C1632.4 366.164 1689.61 391.884 1749.11 431.189",
    stroke: "url(#paint3_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 359.081C163.35 308.929 338.513 338.608 514.452 392.914C591.847 416.799 669.454 429.868 747.531 403.44C788.064 389.727 826.362 367.354 863.342 341.087C918.695 301.782 967.673 236.114 1023.21 200.994C1172.5 106.579 1279.02 344.66 1411.81 384.19C1472.25 402.185 1512.45 362.655 1568.18 343.244C1634.42 320.195 1692.18 357.375 1749.11 401.38",
    stroke: "url(#paint4_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 314.884C159.821 258.004 320.375 305.485 489.986 368.675C568.746 398 647.459 415.737 727.653 385.317C770.091 369.222 809.589 342.697 847.51 312.47C906.933 265.118 958.192 189.631 1018.01 146.689C1175.13 33.9257 1268.31 310.41 1404.1 354.446C1467.92 375.145 1505.3 327.696 1562.13 303.199C1630.92 273.552 1692.06 322.803 1749.08 371.572",
    stroke: "url(#paint5_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 270.204C151.941 207.175 293.91 269.431 452.324 340.701C530.895 376.046 609.255 402.507 691.143 373.535C815.729 329.466 896.935 195.361 1001.64 105.002C1171.68 -41.6902 1247.45 284.979 1395.79 326.569C1460.01 344.596 1496.34 288.552 1553.1 261.48C1624.99 227.197 1691.35 288.938 1749.11 341.699",
    stroke: "url(#paint6_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 225.749C146.977 154.061 271.515 234.633 420.472 314.498C500.902 357.601 582.249 392.56 667.948 356.925C795.004 304.101 877.81 160.209 982.846 60.1287C1161.42 -109.998 1220.04 253.529 1373.42 296.278C1438.7 314.466 1479 252.274 1534.89 221.918C1613.84 179.04 1686.32 252.016 1749.11 311.987",
    stroke: "url(#paint7_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 182.099C57.4431 144.21 128.369 135.487 203.53 166.068C272.927 194.299 332.514 251.308 398.006 291.643C475.354 339.285 554.82 381.068 639.46 343.115C773.902 282.823 854.826 119.102 964.544 10.491C1142.2 -165.398 1193.88 209.525 1339.73 260.096C1413.58 285.688 1456.37 211.488 1519.16 177.56C1604.01 131.688 1683.28 217.315 1749.11 282.179",
    stroke: "url(#paint8_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 139.961C50.1741 99.4336 115.337 86.8149 184.404 118.49C252.437 149.683 307.696 215.352 370.365 260.805C443.267 313.694 518.286 366.776 602.174 332.911C742.826 276.192 831.113 92.3195 940.267 -26.6566C1126.39 -229.553 1157.28 178.461 1309.76 225.427C1388.01 249.538 1436.73 163.493 1503.91 129.95C1594.29 84.8513 1680.98 183.386 1749.08 252.338",
    stroke: "url(#paint9_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 99.9481C135.921 -11.1091 226.701 120.26 349.804 226.425C419.719 286.717 494.997 356.474 580.673 317.653C719.42 254.785 810.694 65.7619 915.872 -59.9421C983.763 -141.062 1048.76 -159.894 1106.91 -57.2703C1157.35 31.7043 1189.74 159.855 1279.49 185.639C1357.64 208.076 1412.82 120.003 1479.87 84.1105C1578.53 31.2536 1676.2 146.818 1749.11 222.562",
    stroke: "url(#paint10_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 62.7364C131.169 -63.1607 222.396 67.565 337.854 186.219C399.441 249.506 469.167 337.161 552.373 307.449C603.021 289.358 647.929 237.949 686.603 192.561C760.94 105.357 822.645 2.47573 893.218 -89.6535C960.874 -177.984 1027.57 -212.75 1085.58 -96.2204C1128.81 -9.3704 1161.98 124.8 1248.91 143.76C1331.55 161.787 1392.03 64.7643 1464.51 31.2218C1569.05 -17.1927 1674.44 112.921 1749.11 192.689",
    stroke: "url(#paint11_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 29.0003C41.8464 -27.1722 104.821 -62.4208 174.359 -28.2023C236.276 2.2821 284.406 73.1013 331.996 132.106C385.632 198.612 453.382 316.687 535.718 293.477C582.061 280.408 622.828 231.865 657.456 190.532C733.887 99.2721 800.885 -6.44148 869.599 -108.131C933.915 -203.351 1005.19 -271.852 1065.18 -139.324C1105.57 -50.124 1136.93 90.9669 1228.53 95.9243C1309.83 100.334 1370.93 11.4886 1444.21 -21.2814C1556.61 -71.5308 1670.63 76.1593 1749.13 162.913",
    stroke: "url(#paint12_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -1.9673C43.352 -64.4169 108.609 -105.878 182.593 -69.8892C245.027 -39.5336 296.733 29.676 342.888 91.9002C390.878 156.635 455.288 283.788 533.859 262.091C577.826 249.956 616.5 201.316 648.917 161.85C723.042 71.5559 789.24 -31.3894 856.214 -131.277C917.542 -222.73 989.574 -306.103 1050.41 -174.187C1090.21 -87.8838 1120.44 49.8594 1210.33 51.5655C1290.92 53.0785 1358.13 -26.9793 1433.39 -54.4056C1550.51 -97.1224 1664.98 42.9063 1749.11 132.364",
    stroke: "url(#paint13_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -36.4753C49.3978 -106.039 118.348 -143.444 197.343 -95.1586C262.67 -55.2101 319.881 20.3732 370.435 87.2972C415.79 147.365 471.99 248.733 543.504 217.154C587.142 197.872 625.087 146.367 657.645 104.97C722.901 22.0148 783.547 -67.8288 845.11 -155.838C903.78 -239.758 974.965 -321.393 1038.03 -204.381C1082.9 -121.136 1111.45 12.0036 1201.01 18.0876C1280.78 23.4956 1357.92 -48.5146 1434.82 -67.8289C1551.12 -97.0578 1659.29 12.6475 1749.13 97.1797",
    stroke: "url(#paint14_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -74.8141C54.2673 -147.371 125.076 -179.272 206.258 -121.973C268.457 -78.0976 325.856 -7.43935 377.022 57.0382C424.706 117.138 483.258 220.695 555.313 174.856C592.929 150.938 623.887 105.388 653.434 66.8563C715.585 -14.2638 774.373 -100.277 835.066 -183.393C897.852 -269.374 968.99 -336.04 1034.13 -221.732C1078.97 -143.026 1111.27 -19.1245 1196.28 -13.974C1274.5 -9.20982 1352.2 -60.4893 1428.54 -77.5503C1546.37 -103.882 1650.99 -21.6675 1749.13 57.5533",
    stroke: "url(#paint15_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -116.276C64.9239 -195.4 141.378 -213.298 226.725 -139.678C288.053 -86.7891 344.747 -15.133 399.629 49.4733C445.454 103.425 496.996 188.118 561.124 139.059C595.47 112.792 624.052 65.9549 651.411 28.0667C709.657 -52.6349 766.374 -135.3 826.315 -213.684C888.419 -294.901 959.51 -353.52 1025.61 -250.896C1074.97 -174.283 1109.15 -52.0877 1193.95 -41.0141C1268.69 -31.2604 1350.13 -71.2411 1423.65 -86.8213C1541.13 -111.705 1644.49 -54.8883 1749.08 14.4823",
    stroke: "url(#paint16_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -160.087C71.6048 -240.016 151.447 -248.579 238.463 -164.948C304.12 -101.854 363.119 -22.1185 425.553 47.0267C468.485 94.5399 515.981 159.693 569.64 105.098C605.115 69.0128 634.073 14.6431 663.526 -29.651C713.327 -104.494 764.375 -178.339 819.163 -246.39C886.302 -329.795 959.11 -369.197 1026.72 -268.666C1076.21 -195.078 1114.14 -80.2224 1195.46 -67.7647C1272.43 -55.983 1355.66 -83.6345 1431.9 -97.9593C1544.02 -119.012 1643.81 -84.729 1749.11 -31.3893",
    stroke: "url(#paint17_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -205.572C83.7669 -290.266 167.914 -281.252 258.788 -181.977C327.738 -106.651 386.502 -18.9961 458.369 52.0805C507.677 100.817 543.222 128.34 588.224 60.4179C664.702 -55.0173 726.642 -186.58 816.246 -286.113C882.02 -359.153 954.381 -386.386 1019.92 -301.371C1075.3 -229.554 1112.56 -119.302 1192.5 -93.4205C1266.29 -69.5673 1358.91 -93.0986 1433.1 -106.941C1542.61 -127.382 1641.43 -115.374 1749.13 -79.0636",
    stroke: "url(#paint18_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -251.958C95.6232 -340.45 185.886 -311.704 279.349 -198.426C346.299 -117.273 401.981 -23.3092 477.965 43.3574C533.742 92.3191 563.1 100.978 601.257 23.0129C661.714 -100.502 722.572 -226.753 810.647 -317.852C881.856 -391.536 954.005 -408.082 1023.59 -323.132C1081.53 -252.377 1122.77 -138.551 1204.7 -113.507C1277.37 -91.2956 1362.18 -101.854 1435.43 -115.503C1541.79 -135.332 1641.69 -144.281 1749.13 -127.896",
    stroke: "url(#paint19_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -298.506C105.598 -389.766 200.119 -344.796 295.886 -219.929C363.66 -131.566 419.531 -23.6312 502.972 39.0115C564.911 85.5268 586.648 61.3518 616.195 -18.3841C663.196 -145.183 722.642 -273.333 809.706 -355.934C883.408 -425.884 957.957 -428.041 1027.19 -347.661C1087.58 -277.518 1131.57 -166.654 1212.47 -135.558C1385.98 -68.8589 1574.81 -168.553 1749.13 -176.826",
    stroke: "url(#paint20_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -344.506C44.8811 -388.317 101.387 -414.327 168.643 -382.426C224.278 -356.03 269.845 -300.63 310.66 -244.2C377.987 -151.041 435.551 -25.6912 525.249 29.6765C592.529 71.2023 608.455 15.2551 631.156 -62.8068C668.16 -190.152 724.03 -320.621 811.329 -395.174C1001.59 -557.704 1070.26 -228.845 1221.64 -157.543C1398.43 -74.2666 1576.25 -179.336 1749.13 -225.144",
    stroke: "url(#paint21_linear_431_395)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2238 -389.219C47.4688 -434.607 105.245 -459.909 173.724 -425.433C231.171 -396.526 277.608 -337.456 319.223 -277.614C384.667 -183.521 452.347 -20.6372 549.973 16.8325C618.312 43.0678 629.086 -44.426 646.4 -114.859C676.699 -238.148 728.924 -374.089 816.293 -439.307C997.666 -574.7 1089.01 -270.275 1225.95 -184.229C1405.6 -71.3373 1579.57 -187.094 1749.11 -272.013",
    stroke: "url(#paint22_linear_431_395)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_395",
    x1: 866.941,
    y1: 462.97,
    x2: 866.941,
    y2: 520.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_431_395",
    x1: 866.941,
    y1: 385.229,
    x2: 866.941,
    y2: 490.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_431_395",
    x1: 866.953,
    y1: 310.12,
    x2: 866.953,
    y2: 460.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_431_395",
    x1: 866.941,
    y1: 245.242,
    x2: 866.941,
    y2: 437.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_431_395",
    x1: 866.941,
    y1: 179.027,
    x2: 866.941,
    y2: 418.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_431_395",
    x1: 866.929,
    y1: 119.866,
    x2: 866.929,
    y2: 401.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_431_395",
    x1: 866.941,
    y1: 67.374,
    x2: 866.941,
    y2: 385.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_431_395",
    x1: 866.941,
    y1: 15.084,
    x2: 866.941,
    y2: 371.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_431_395",
    x1: 866.941,
    y1: -36.1221,
    x2: 866.941,
    y2: 357.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_431_395",
    x1: 866.929,
    y1: -82.873,
    x2: 866.929,
    y2: 343.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_431_395",
    x1: 866.941,
    y1: -127.643,
    x2: 866.941,
    y2: 328.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_431_395",
    x1: 866.941,
    y1: -170.529,
    x2: 866.941,
    y2: 313.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_431_395",
    x1: 866.953,
    y1: -213.021,
    x2: 866.953,
    y2: 296.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_431_395",
    x1: 866.941,
    y1: -242.695,
    x2: 866.941,
    y2: 264.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_431_395",
    x1: 866.953,
    y1: -262.684,
    x2: 866.953,
    y2: 223.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_431_395",
    x1: 866.953,
    y1: -282.516,
    x2: 866.953,
    y2: 186.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_431_395",
    x1: 866.929,
    y1: -305.645,
    x2: 866.929,
    y2: 153.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_431_395",
    x1: 866.941,
    y1: -328.39,
    x2: 866.941,
    y2: 125.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_431_395",
    x1: 866.953,
    y1: -354.064,
    x2: 866.953,
    y2: 100.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_431_395",
    x1: 866.953,
    y1: -380.26,
    x2: 866.953,
    y2: 80.8842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_431_395",
    x1: 866.953,
    y1: -408.194,
    x2: 866.953,
    y2: 62.5368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_431_395",
    x1: 866.953,
    y1: -439.753,
    x2: 866.953,
    y2: 43.7815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_431_395",
    x1: 866.941,
    y1: -473.514,
    x2: 866.941,
    y2: 21.5953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractOpacoServices);
export default __webpack_public_path__ + "static/media/AbstractOpacoServices.24df3f0e578d75715f1906fd660e9d65.svg";
export { ForwardRef as ReactComponent };